import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#3826D8", // "#0080AA",
        "legacy-primary": "#0080AA",
        "legacy-secondary": "#00A8E1",
        secondary: "#00A8E1",
        "plus-text": "#53657B",
        accent: "#8C9EFF",
        error: "#EA0C0C",
        // anchor, info, success, warning left unchanged
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: "md",
  },
});
